import {AppAction} from "../../root/AppAction";
import {VideoFilter} from "./models/VideoFilter";
import VideoFilterEvents from "./VideoFilterEvents";

export interface VideoFilterStore {
    videoFilters: VideoFilter;
}

const initialStore: VideoFilterStore = {
    videoFilters: {id:[], professional:[], program:[], project:[], tag:[], slideFlg: false}
};

export default function videoFilter(state: VideoFilterStore = initialStore, action: AppAction) {
    if (action.type === VideoFilterEvents.resetfilter) {
        return {
            videoFilters: action.videoFilters
       };
   } else {
        return state;
   }
}
